var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        { staticClass: "justify-content-end" },
        [
          _c("b-col", { staticClass: "my-1", attrs: { md: "10" } }),
          _c(
            "b-col",
            { attrs: { lg: "2" } },
            [
              _vm.HasPermission(_vm.PermissionList.Sales_Create)
                ? _c(
                    "b-button",
                    {
                      staticClass: "float-right my-1",
                      attrs: { variant: "success" },
                      on: { click: _vm.openAddNoteModal },
                    },
                    [
                      _c("feather-icon", { attrs: { icon: "PlusIcon" } }),
                      _vm._v("Add Note"),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-col",
        {
          staticClass: "d-flex justify-content-end mb-2",
          staticStyle: { position: "relative", "z-index": "1" },
          attrs: { cols: "12" },
        },
        [
          _c(
            "b-button",
            {
              attrs: { variant: "outline-danger", size: "sm" },
              on: { click: _vm.clearFilters },
            },
            [_vm._v(" Clear Filters ")]
          ),
        ],
        1
      ),
      _vm.loading
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-center" },
            [
              _c("b-spinner", {
                staticStyle: { width: "3rem", height: "3rem" },
                attrs: { variant: "success", label: "Spinning" },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { lg: "12" } },
            [
              _c("b-table", {
                attrs: {
                  striped: "",
                  hover: "",
                  responsive: "",
                  items: _vm.paginatedNotes,
                  fields: _vm.fields,
                },
                scopedSlots: _vm._u([
                  {
                    key: "head(title)",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Title")]),
                            _c("b-form-input", {
                              attrs: {
                                placeholder: "Filter by Title",
                                size: "sm",
                              },
                              model: {
                                value: _vm.filters.title,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "title", $$v)
                                },
                                expression: "filters.title",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "head(description)",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Description")]),
                            _c("b-form-input", {
                              attrs: {
                                placeholder: "Filter by Description",
                                size: "sm",
                              },
                              model: {
                                value: _vm.filters.description,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "description", $$v)
                                },
                                expression: "filters.description",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "head(salesPerson)",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Sales Person")]),
                            _c("b-form-input", {
                              attrs: {
                                placeholder: "Filter by Sales Person",
                                size: "sm",
                              },
                              model: {
                                value: _vm.filters.salesPerson,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "salesPerson", $$v)
                                },
                                expression: "filters.salesPerson",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "head(importance)",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Tag")]),
                            _c("b-form-select", {
                              attrs: { options: _vm.tagOptions, size: "sm" },
                              model: {
                                value: _vm.filters.importance,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "importance", $$v)
                                },
                                expression: "filters.importance",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "head(dueDate)",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Due Date")]),
                            _c("DatePicker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                range: "",
                                format: "YYYY-MM-DD",
                                placeholder: "Select date range",
                                size: "sm",
                              },
                              on: { change: _vm.applyDateFilters },
                              model: {
                                value: _vm.filters.dueDateRange,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "dueDateRange", $$v)
                                },
                                expression: "filters.dueDateRange",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "head(createdOn)",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Created On")]),
                            _c("DatePicker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                range: "",
                                format: "YYYY-MM-DD",
                                placeholder: "Select date range",
                                size: "sm",
                              },
                              on: { change: _vm.applyDateFilters },
                              model: {
                                value: _vm.filters.createdOnRange,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "createdOnRange", $$v)
                                },
                                expression: "filters.createdOnRange",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "cell(title)",
                    fn: function (data) {
                      return [
                        _c("h5", [_vm._v(_vm._s(data.item.title || "-N/A-"))]),
                      ]
                    },
                  },
                  {
                    key: "cell(description)",
                    fn: function (data) {
                      return [
                        _c("h5", [
                          _vm._v(
                            _vm._s(data.item.description || "no description")
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "cell(salesPerson)",
                    fn: function (data) {
                      return [
                        _c("h5", [
                          _vm._v(
                            _vm._s(
                              _vm.getSalePersonName(data.item.salesPersonId)
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "cell(createdOn)",
                    fn: function (data) {
                      return [
                        _c("h6", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.formatDate(data.item.created_On) || "-N/A-"
                              ) +
                              " "
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "cell(importance)",
                    fn: function (data) {
                      return [
                        _c(
                          "b-badge",
                          {
                            staticClass: "d-flex",
                            attrs: { variant: "bg-transparent" },
                          },
                          [
                            _c("feather-icon", {
                              class: [
                                "mr-1 text-" +
                                  _vm.getImportanceVariant(
                                    data.item.isImportant
                                  ),
                              ],
                              attrs: { icon: "CircleIcon", size: "20" },
                            }),
                            _c("h5", [
                              _vm._v(
                                _vm._s(
                                  data.item.isImportant ? "Important" : "Mild"
                                )
                              ),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "cell(dueDate)",
                    fn: function (data) {
                      return [
                        _c("h6", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.formatDate(data.item.dueDate) || "-N/A-"
                              ) +
                              " "
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "cell(actions)",
                    fn: function (data) {
                      return [
                        _c(
                          "b-dropdown",
                          {
                            attrs: {
                              variant: "link",
                              "toggle-class": "text-decoration-none",
                              "no-caret": "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "button-content",
                                  fn: function () {
                                    return [
                                      _c("feather-icon", {
                                        staticClass:
                                          "text-body align-middle mr-25",
                                        attrs: {
                                          icon: "MoreHorizontalIcon",
                                          size: "16",
                                        },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c(
                              "b-dropdown-item",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openEditModal(data.item)
                                  },
                                },
                              },
                              [
                                _c("feather-icon", {
                                  staticClass: "mr-50",
                                  attrs: { icon: "EditIcon" },
                                }),
                                _c("span", [_vm._v("View / Edit")]),
                              ],
                              1
                            ),
                            _c(
                              "b-dropdown-item",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.confirmDelete(data.item)
                                  },
                                },
                              },
                              [
                                _c("feather-icon", {
                                  staticClass: "mr-50 text-danger",
                                  attrs: { icon: "Trash2Icon" },
                                }),
                                _c("span", { staticClass: "text-danger" }, [
                                  _vm._v("Delete"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("b-pagination", {
                staticClass: "my-3",
                attrs: {
                  "total-rows": _vm.totalRows,
                  "per-page": _vm.perPage,
                  align: "center",
                },
                model: {
                  value: _vm.currentPage,
                  callback: function ($$v) {
                    _vm.currentPage = $$v
                  },
                  expression: "currentPage",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "addNoteModal",
            title: "Add Note",
            centered: "",
            size: "lg",
          },
          on: { ok: _vm.handleAddNote },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function () {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { disabled: _vm.loadingAdd },
                      on: { click: _vm.handleAddNote },
                    },
                    [
                      _vm.loadingAdd
                        ? _c("b-spinner", {
                            attrs: { type: "grow", small: "" },
                          })
                        : _vm._e(),
                      !_vm.loadingAdd
                        ? _c("span", [_vm._v("Add Note")])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.showAddNoteModal,
            callback: function ($$v) {
              _vm.showAddNoteModal = $$v
            },
            expression: "showAddNoteModal",
          },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Note Title",
                        "label-for": "noteTitleInput",
                        state: _vm.titleValidation,
                        "invalid-feedback": _vm.titleError,
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { id: "noteTitleInput", required: "" },
                        on: { change: _vm.validateTitle },
                        model: {
                          value: _vm.title,
                          callback: function ($$v) {
                            _vm.title = $$v
                          },
                          expression: "title",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Tag", "label-for": "tagInput" } },
                    [
                      _c("v-select", {
                        attrs: {
                          dir: _vm.$store.state.appConfig.isRTL ? "rtl" : "ltr",
                          options: _vm.optionTags,
                          label: "title",
                        },
                        model: {
                          value: _vm.selectedTag,
                          callback: function ($$v) {
                            _vm.selectedTag = $$v
                          },
                          expression: "selectedTag",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Sales Person",
                        "label-for": "salesPersonInput",
                        state: _vm.salespersonValidation,
                        "invalid-feedback": _vm.salespersonError,
                      },
                    },
                    [
                      _c("b-form-select", {
                        attrs: {
                          id: "salesPersonId",
                          options: _vm.optionsSalesPerson,
                          required: "",
                        },
                        on: { input: _vm.validateSalesperson },
                        model: {
                          value: _vm.salesPersonId,
                          callback: function ($$v) {
                            _vm.salesPersonId = $$v
                          },
                          expression: "salesPersonId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Due Date",
                        "label-for": "dueDateInput",
                        state: _vm.dueDateValidation,
                        "invalid-feedback": _vm.dueDateError,
                      },
                    },
                    [
                      _c("b-form-datepicker", {
                        staticClass: "mb",
                        attrs: { id: "example-purchase", required: "" },
                        on: { input: _vm.validateDueDate },
                        model: {
                          value: _vm.dueDate,
                          callback: function ($$v) {
                            _vm.dueDate = $$v
                          },
                          expression: "dueDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Description",
                        "label-for": "editDescription",
                      },
                    },
                    [
                      _c("b-form-textarea", {
                        attrs: { id: "editDescription" },
                        model: {
                          value: _vm.description,
                          callback: function ($$v) {
                            _vm.description = $$v
                          },
                          expression: "description",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: { id: "viewModal", title: "View Note", centered: "" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function () {
                return undefined
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.showViewModal,
            callback: function ($$v) {
              _vm.showViewModal = $$v
            },
            expression: "showViewModal",
          },
        },
        [
          _c("p", [
            _c("strong", [_vm._v("Note Title: ")]),
            _vm._v(_vm._s(_vm.selectedNote.title)),
          ]),
          _c("p", [
            _c("strong", [_vm._v("Sales Person: ")]),
            _vm._v(
              _vm._s(_vm.getSalePersonName(_vm.selectedNote.salesPersonId)) +
                " "
            ),
          ]),
          _c("p", [
            _c("strong", [_vm._v("Description: ")]),
            _vm._v(_vm._s(_vm.selectedNote.description)),
          ]),
          _c("p", [
            _c("strong", [_vm._v("Date: ")]),
            _vm._v(_vm._s(_vm.formatDate(_vm.selectedNote.dueDate))),
          ]),
          _c(
            "p",
            [
              _c("strong", [_vm._v("Status: ")]),
              _c(
                "b-badge",
                { staticClass: "d-flex", attrs: { variant: "bg-transparent" } },
                [
                  _c("feather-icon", {
                    class: [
                      "mr-1 text-" +
                        _vm.getImportanceVariant(_vm.selectedNote.isImportant),
                    ],
                    attrs: { icon: "CircleIcon", size: "20" },
                  }),
                  _c("h5", [
                    _vm._v(
                      _vm._s(
                        _vm.selectedNote.isImportant ? "Important" : "Mild"
                      )
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "editNoteModal",
            title: "Add Note",
            centered: "",
            size: "lg",
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function () {
                return [
                  _vm.isEdit
                    ? _c(
                        "b-button",
                        { on: { click: _vm.handleEditNote } },
                        [
                          _vm.loading
                            ? _c("b-spinner", {
                                attrs: { type: "grow", small: "" },
                              })
                            : _vm._e(),
                          !_vm.loading
                            ? _c("span", [_vm._v("Update Note")])
                            : _vm._e(),
                        ],
                        1
                      )
                    : _c(
                        "b-button",
                        {
                          staticStyle: { visibility: "hidden" },
                          attrs: { disabled: "" },
                        },
                        [_c("span")]
                      ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.showEditNoteModal,
            callback: function ($$v) {
              _vm.showEditNoteModal = $$v
            },
            expression: "showEditNoteModal",
          },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Note Title",
                        "label-for": "noteTitleInput",
                        state: _vm.editTitleValidation,
                        "invalid-feedback": _vm.editTitleError,
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "noteTitleInput",
                          required: "",
                          disabled: !_vm.isEdit,
                        },
                        on: { change: _vm.validateEditTitle },
                        model: {
                          value: _vm.selectedNote.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.selectedNote, "title", $$v)
                          },
                          expression: "selectedNote.title",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Tag", "label-for": "tagInput" } },
                    [
                      _c("v-select", {
                        attrs: {
                          dir: _vm.$store.state.appConfig.isRTL ? "rtl" : "ltr",
                          options: _vm.optionTags,
                          label: "title",
                          disabled: !_vm.isEdit,
                          clearable: false,
                        },
                        model: {
                          value: _vm.selectedTag,
                          callback: function ($$v) {
                            _vm.selectedTag = $$v
                          },
                          expression: "selectedTag",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Sales Person",
                        "label-for": "salesPersonInput",
                      },
                    },
                    [
                      _c("b-form-select", {
                        attrs: {
                          disabled: !_vm.isEdit,
                          options: _vm.optionsSalesPerson,
                        },
                        model: {
                          value: _vm.selectedNote.salesPersonId,
                          callback: function ($$v) {
                            _vm.$set(_vm.selectedNote, "salesPersonId", $$v)
                          },
                          expression: "selectedNote.salesPersonId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Due Date",
                        "label-for": "dueDateInput",
                        state: _vm.editDueDateValidation,
                        "invalid-feedback": _vm.editDueDateError,
                      },
                    },
                    [
                      _c("b-form-datepicker", {
                        staticClass: "mb-1",
                        attrs: {
                          id: "example-purchase",
                          required: "",
                          disabled: !_vm.isEdit,
                        },
                        on: { blur: _vm.validateEditDueDate },
                        model: {
                          value: _vm.selectedNote.dueDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.selectedNote, "dueDate", $$v)
                          },
                          expression: "selectedNote.dueDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Description",
                        "label-for": "editDescription",
                      },
                    },
                    [
                      _c("b-form-textarea", {
                        attrs: { id: "editDescription", disabled: !_vm.isEdit },
                        model: {
                          value: _vm.selectedNote.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.selectedNote, "description", $$v)
                          },
                          expression: "selectedNote.description",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }